module.exports = __webpack_public_path__ + "static/media/ExerciseIconMath.92fadccf.svg";